// sale all products countdown js ==================

jQuery(document).ready(function () {
  function updateCountdown() {
    var now = new Date().getTime();

    jQuery(".sale_countdown").each(function () {
      var startDate = new Date(jQuery(this).data("start-date")).getTime();
      var endDate = new Date(jQuery(this).data("end-date")).getTime();
      var timeLeft = endDate - now;

      if (now >= startDate && now <= endDate) {
        var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
        jQuery(this).find(".countdown-days").text(days);
        jQuery(this).find(".countdown-hours").text(hours);
        jQuery(this).find(".countdown-minutes").text(minutes);
        jQuery(this).find(".countdown-seconds").text(seconds);
      } else {
        jQuery(this)
          .find(
            ".countdown-days, .countdown-hours, .countdown-minutes, .countdown-seconds"
          )
          .text("00");
      }
    });
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);
});

// Instagram slider js ==================

var swiper = new Swiper(".instaswiper", {
  slidesPerView: 1,
  navigation: {
    nextEl: ".instaswiper .swiper-button-next",
    prevEl: ".instaswiper .swiper-button-prev",
  },
  breakpoints: {
    426: {
      slidesPerView: 2,
    },
    576: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 5,
    },
  },
});

// review slider ================

var swiper = new Swiper(".review_sliders", {
  spaceBetween: 10,
  pagination: {
    el: ".review_sliders .swiper-pagination",
    clickable: true,
  },
});

// faq section ===================

$(document).ready(function () {
  $(".faqs_left_block .faqs_main_block:first-child p.faq_answer").slideDown();
  $(".faqs_left_block .faqs_main_block:first-child").addClass("active");
  // $(".faqs_right_block .faqs_main_block:first-child p.faq_answer").slideDown();
  // $(".faqs_right_block .faqs_main_block:first-child").addClass("active");
  $(".faqs_main_block").click(function () {
    var $currentFaq = $(this).find("p.faq_answer");
    if ($currentFaq.is(":visible")) {
      $currentFaq.slideUp();
      $(this).removeClass("active");
    } else {
      $(".faqs_main_block").removeClass("active");
      $(".faqs_main_block p.faq_answer").slideUp();
      $currentFaq.slideDown();
      $(this).addClass("active");
    }
  });
});

// header active

document.addEventListener("DOMContentLoaded", function () {
  // Get the current URL path
  var currentPageUrl = window.location.pathname.replace(/\/$/, "");

  // Select all links in the bottom-fixbar
  var links = document.querySelectorAll(".top-menu .top_menu_main_custom");

  // Loop through each link
  links.forEach(function (link) {
    // Get the link's href path without the trailing slash
    var linkPath = link.getAttribute("href").replace(/\/$/, "");

    // Check if the link's href matches the current URL
    if (linkPath === currentPageUrl) {
      // Add the 'active' class to the parent li element
      link.parentNode.classList.add("active");
    }
  });
});

//  header scroll off over hidden

$(".mobile-width-left .menu-icon").on("click", function (e) {
  e.stopPropagation();
  $("html").addClass("over-hidden");
});
$(".mobile-menu-overlay, #top_menu_closer svg").on("click", function () {
  $("html").removeClass("over-hidden");
});
$(".mobile-width-left .menu-icon").on("click", function (e) {
  e.stopPropagation();
});

// filter

// $('.product-checkbox').each(function() {
//     var productUrl = $(this).data('product-url');
//     if (localStorage.getItem('checkedProductUrl') === productUrl) {
//         $(this).prop('checked', true);
//     }
// });

// function handleCheckboxCheck(checkbox) {
//     var productUrl = checkbox.data('product-url');

//     $('.product-checkbox').not(checkbox).prop('checked', false);

//     checkbox.prop('checked', true);
//     localStorage.setItem('checkedProductUrl', productUrl);

//     window.location.href = productUrl;
// }

// $('.product-checkbox').on('click', function() {
//     handleCheckboxCheck($(this));
// });

// $('.checkbox-link').on('click', function(e) {
//     e.preventDefault();

//     var checkbox = $(this).closest('.panel-title').find('.product-checkbox');
//     handleCheckboxCheck(checkbox);
// });

// ==========================================
$(document).ready(function () {
  // On page load, set the checked state based on localStorage
  var checkedProductUrl = localStorage.getItem("checkedProductUrl");
  if (checkedProductUrl) {
    $(".product-checkbox").each(function () {
      var productUrl = $(this).data("product-url");
      if (productUrl === checkedProductUrl) {
        $(this).prop("checked", true);
      } else {
        $(this).prop("checked", false);
      }
    });
  }

  // Handle checkbox check
  function handleCheckboxCheck(checkbox) {
    var productUrl = checkbox.data("product-url");

    $(".product-checkbox").not(checkbox).prop("checked", false);
    checkbox.prop("checked", true);
    localStorage.setItem("checkedProductUrl", productUrl);

    // Redirect only if the checkbox is checked
    if (checkbox.is(":checked")) {
      window.location.href = productUrl;
    }
  }

  // Checkbox click event
  $(".product-checkbox").on("click", function () {
    handleCheckboxCheck($(this));
  });

  // Link click event
  $(".checkbox-link").on("click", function (e) {
    e.preventDefault();

    var checkbox = $(this).closest(".panel-title").find(".product-checkbox");
    handleCheckboxCheck(checkbox);
  });
});




